export default "__VITE_ASSET__CrNjJ05E__"